'use strict';

import execute_on from "../../../../libs/execute-on";
import popupScripts from "./popupScripts";

execute_on('admin.cms.popup.edit', popupScripts);
